export const sendEmail = async (
  to: string,
  subject: string,
  html: string,
) => {
  try {
    // Use Vercel API endpoint (works in both development and production)
    const url = '/api/send-email';
    
    const payload = {
      to,
      subject,
      html,
    };

    const res = await fetch(url, {
      method: "POST",
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload)
    });
    
    const json = await res.json();
    return json;
  } catch (error) {
    console.error("SEND EMAIL ERROR", error);
    return null;
  }
}

